module.exports = {"513201100":"马尔康镇","513201101":"卓克基镇","513201102":"松岗镇","513201200":"梭磨乡","513201201":"白湾乡","513201202":"党坝乡","513201203":"木尔宗乡","513201204":"脚木足乡","513201205":"沙尔宗乡","513201206":"龙尔甲乡","513201207":"大藏乡","513201208":"康山乡","513201209":"草登乡","513201210":"日部乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/513201.json
// module id = 2212
// module chunks = 0